module.exports = __webpack_public_path__ + "media/images/boat-ffbdbcf7e87ef4ec8bc6209994da1641.png";